import React, { useState, useEffect } from "react";
import "./SponsorsContent.css";
import AOS from "aos";
import "aos/dist/aos.css";

function SponsorsContent() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);
  return (
    <>
      <div className="main-banner">
        {/* <img
          src="images/Sponsors/sponsors-banner.png"
          alt="banner"
          className="banner-img"
        /> */}
      </div>
      <div className="sponsors-sec">
        <h2>Sponsors</h2>
      </div>
    </>
  );
}

export default SponsorsContent;
